import { render, staticRenderFns } from "./ClassTabs.vue?vue&type=template&id=5489a841&scoped=true&"
import script from "./ClassTabs.vue?vue&type=script&lang=js&"
export * from "./ClassTabs.vue?vue&type=script&lang=js&"
import style0 from "./ClassTabs.vue?vue&type=style&index=0&id=5489a841&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489a841",
  null
  
)

export default component.exports